import "./GatewayCard.css";

import { CheckCircle2 } from "lucide-react";

export default function GatewayCard({

    gateway,

    selected,

    onSelect,

}) {

    return (

        <div

            className={

                `gateway-card  ${selected ? "selected" : ""}`

            }

            onClick={() => onSelect(gateway)}

        >


            <div className="gateway-logo">

                <img

                    src={`/${gateway.logo}`}

                    alt={gateway.name}

                />

            </div>

            <div className="gateway-content">

                <h4>

                    {gateway.name}

                </h4>

                <p>

                    {gateway.description}

                </p>

            </div>

            {
                gateway.recommended && (

                    <span className="recommended-badge">

                        پیشنهاد ما

                    </span>

                )
            }

            {

                selected &&

                <CheckCircle2

                    size={22}

                    color="#16a34a"

                />

            }

            <p className="maintenance-message">

                {gateway.maintenance_message}

            </p>


        </div>

    );

}